import { useState } from "react";
import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";
import { comics } from "@/mocks/comics";

export default function Specials() {
  const [active, setActive] = useState(specials[0].id);
  const current = specials.find((s) => s.id === active) ?? specials[0];
  const list = current.comicIds
    .map((id) => comics.find((c) => c.id === id))
    .filter((c): c is (typeof comics)[number] => Boolean(c));

  return (
    <section>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">
            推荐专题
          </h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">
            编辑精心整理的合集，一次看个够
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {specials.map((s) => (
            <button
              key={s.id}
              type="button"
              onClick={() => setActive(s.id)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                s.id === active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-700"
              }`}
            >
              {s.title}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="relative col-span-1 overflow-hidden rounded-lg bg-foreground-900">
          <div className="h-40 w-full lg:h-full lg:min-h-full">
            <img
              src={current.cover}
              alt={`${current.title} 专题封面`}
              title={`${current.title} 韩漫专题合集`}
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/5" />
          <div className="absolute bottom-0 left-0 w-full p-5">
            <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
              专题合集
            </span>
            <h3 className="mt-3 font-display text-2xl font-extrabold text-white">
              {current.title}
            </h3>
            <p className="mt-1 text-sm text-white/85">{current.subtitle}</p>
            <p className="mt-2 text-xs leading-relaxed text-white/70">
              {current.desc}
            </p>
            <p className="mt-3 text-xs text-primary-300">
              共 {list.length} 部作品
            </p>
          </div>
        </div>

        <div className="col-span-1 grid grid-cols-2 gap-4 lg:col-span-2 lg:grid-cols-3">
          {list.map((comic) => (
            <Link
              key={comic.id}
              to={`/detail/${comic.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 韩漫封面`}
                  title={`${comic.title} 免费韩漫在线阅读`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-3">
                <h4 className="line-clamp-1 text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                  {comic.title}
                </h4>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
                  {comic.author} · {comic.status}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}